import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import _ from 'lodash';
import moment from 'moment';
import MdTrendingUp from 'react-icons/lib/md/trending-up';
import { MdEdit, MdDelete } from 'react-icons/lib/md';
import { fullModalStyle, modalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchProgressReports, fetchContracts } from '../../actions/project_actions';
import ProgressReportForm from './ProgressReportForm';
import { getModifiedDate, getModifiedUser } from '../../utils/meta';

const desktopOnly = {className: 'desktop-only'};

class ProgressReports extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            toEdit: null,
            toDelete: null,
            currentPage: 1,
            itemsPerPage: 10
        }
        this.startEdit = this.startEdit.bind(this);
        this.startDelete = this.startDelete.bind(this);
        this.onDone = this.onDone.bind(this);
        this.callDelete = this.callDelete.bind(this);
        this.putOrPost = this.putOrPost.bind(this);

        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.loadInitial();
        this.props.fetchContracts(this.props.projectId);
    }

    loadInitial () {
        this.props.fetchProgressReports(this.props.projectId);
    }

    getContractorsForForm (toEdit) {
        if (toEdit.id) return [toEdit.contract];

        const month = this.getCurrentMonth();
        const monthReports = _.filter(this.props.progressReports, { month });
        const existingContractIds = _.map(monthReports, 'contractId');
        return this.props.contracts.filter(contract =>
      existingContractIds.indexOf(contract.id) === -1);
    }

    getCurrentMonth () {
        return moment().format('MMMM Y');
    }

    getFreshProps () {
        let index = 1;
        let monthIndex = 1;
        const month = this.getCurrentMonth();
        const lastReport = _.last(this.props.progressReports);

        if (lastReport && lastReport.month === month) {
            index = lastReport.index;
            monthIndex = lastReport.monthIndex + 1;
        }

        let title = 'Monthly Progress Report ' + _.padStart(index, 3, '000') +
                '-' + _.padStart(monthIndex, 2, '00') + ' | ' +  month;
        return { title, index, month, monthIndex }
    }

    canUserEdit () {
        const { roleModules } = this.props.permissions.editPrivileges;
        const canEditReport = roleModules !== null && roleModules.includes('Progress reports') 
    ? true : false;

        return canEditReport;
    }

    startEdit (toEdit) {
        if (!toEdit.title) {
            Object.assign(toEdit, this.getFreshProps())
        }
        this.setState({ toEdit })
    }

    startDelete (toDelete) {
        this.setState({ toDelete })
    }

    onDone (shouldFetch) {
        if (shouldFetch) this.loadInitial();
        this.setState({ toEdit: null, toDelete: null});
    }

    callDelete () {
        const { projectId, id } = this.state.toDelete;
        const url = `/projects/${projectId}/progressReports/${id}`;
        withAuth(
      {method: 'delete', url: url},
      () => this.onDone(true)
    );
    }

    putOrPost (report) {
        let url, method;
        const { projectId } = this.props
        report.projectId = projectId;

        if (report.id) {
            method = 'put';
            url = `/projects/${projectId}/progressReports/${report.id}`;
        } else {
            method = 'post';
            url = `/projects/${projectId}/progressReports/`;
        }

        withAuth(
      {method, url, data: report},
      () => this.onDone(true)
    );
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    } 

    changeNumItemsShown(e) {
        if (e.target.value < 5 || e.target.value > this.props.progressReports.length) {
            //console.log(this.state.currentPage);
        } else {
            this.setState({ itemsPerPage: e.target.value });
        }
    }

    renderDeleteForm () {
        return (
      <div className="alert-modal">
        <h1>Confirm Delete?</h1>
        <p>Are you sure you want to delete?</p>
        <button className="alert-cancel" onClick={this.callDelete}>Yes</button>
        <div className="modal-close" onClick={this.onDone}>
          <span className="close"></span>
        </div>
      </div>
        )
    }

    renderEditForm (toEdit) {
        return (
      <div className="progress-report">
        <ProgressReportForm
          projectId={this.props.projectId}
          report={toEdit}
          contracts={this.getContractorsForForm(toEdit)}
          onSubmit={this.putOrPost}
        />
        <div className="modal-close" onClick={this.onDone}>
          <span className="close"></span>
        </div>
      </div>
        );
    }

    renderModal () {
        const { toEdit, toDelete } = this.state;
        const isOpen = !(toEdit === null && toDelete === null);

        return (
      <Modal
        isOpen={isOpen}
        style={toEdit ? fullModalStyle : modalStyle}
        contentLabel="Report form"
      >
        {toDelete && this.renderDeleteForm()}
        {toEdit && this.renderEditForm(toEdit)}
      </Modal>
        );
    }

    renderRowButtons (report) {
        if (report.month !== this.getCurrentMonth()) return <td></td>;

        return (
      <td>
        <button onClick={() => this.startEdit(report)}>
        <span><MdEdit size={22} color='#8492a6'/></span>
        </button>
        <button onClick={() => this.startDelete(report)}>
        <span><MdDelete size={22} color='#8492a6'/></span>
        </button>
      </td>
        )
    }

    renderTable (progressReports) {
        const canEdit = this.canUserEdit();

        return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Contractor</th>
              <th {...desktopOnly}>Date Modified</th>
              <th {...desktopOnly}>Modified by</th>
              { canEdit ? <th>Actions</th> : null}
            </tr>
          </thead>
          <tbody>
          { progressReports.map(report =>
            <tr key={report.id}>
              <td id={'report-' + report.id}>
                <Link to={'#report-' + report.id}>{report.title}</Link>
              </td>
              <td>{report.contract.contractor}</td>
              <td {...desktopOnly}>{getModifiedDate(report)}</td>
              <td {...desktopOnly}>{getModifiedUser(report)}</td>
              { canEdit ? this.renderRowButtons(report) : null }
            </tr>
          )}
          </tbody>
        </table>
      </div>
        );
    }

    render () {
        const { progressReports, contracts } = this.props;
        const monthReports = _.filter(progressReports, {month: this.getCurrentMonth()});

        const canEdit = this.canUserEdit();
        const canAdd = canEdit && (monthReports.length < contracts.length);

        const { currentPage, itemsPerPage } = this.state;

    // Logic for displaying items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentReports = this.props.progressReports.slice(indexOfFirstItem, indexOfLastItem);

    // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.progressReports.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        return (
      <div id="progress-reports" className="row-wide project-reports">
        <div className="col s12">
          <h4 className="bar-bottom">
            <span><MdTrendingUp size={20}/></span> Progress Reports
          </h4>
        </div>
        { canEdit ? this.renderModal() : null }
        <div className="col s12">
          { progressReports.length
            ? this.renderTable(currentReports)
            : <div>This project has no progress reports yet.</div> }
        </div>
        { canAdd
          ? <div className="section-buttons">
              <button className="btn-save" onClick={() => this.startEdit({})}>
                Add
              </button>
            </div>
         : null }

        {pageNumbers.length > 1 &&
          <div>
            <div className="col s12">
              <div className="controls margin-top-1">
                <label className="label-pagination">Show</label>
                <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                  min="5" max={this.props.progressReports.length - 1} className="input-pagination" />
                <span className="label-pagination">per page</span>
              </div>
            </div>

            <div className="col s12">
              <div className="pagination-blue-book">
                <ul id="page-numbers">
                  {pageNumbers.map(number => {
                      return <li
                      key={number}
                      id={number}
                      onClick={this.handleClick}
                      className={currentPage === number ? 'active' : ''}
                    >
                      {number}
                    </li>
                  })}
                </ul>
              </div>
            </div>
          </div>
        }
      </div>
        );
    }
}

ProgressReports.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    progressReports: PropTypes.array.isRequired,
    contracts: PropTypes.array.isRequired,
    fetchProgressReports: PropTypes.func.isRequired,
    fetchContracts: PropTypes.func.isRequired,
};

function mapStateToProps (state, ownProps) {
    return {
        projectId: ownProps.projectId,
        progressReports: state.projectsStore.progressReports,
        contracts: state.projectsStore.contracts,
    };
}

export default connect(mapStateToProps, {
    fetchProgressReports,
    fetchContracts,
})(ProgressReports);